'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPointspayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M42.7274 18.1238C40.4899 14.9752 36.7869 13.05 32.6185 13.05C25.8301 13.05 20.2758 18.3158 20.2758 25.3368C20.2758 25.3908 20.2762 25.4447 20.2768 25.4985L20.2758 25.4964V44.3256C20.2758 45.4426 21.2016 46.4 22.4358 46.4C23.6701 46.4 24.5958 45.4426 24.5958 44.3256V35.0706L24.4614 34.7728C26.6404 36.6714 29.4992 37.7832 32.6185 37.7832C35.6019 37.7832 38.347 36.7662 40.4869 35.0165V44.3256C40.4869 45.4426 41.4126 46.4 42.6469 46.4C43.8811 46.4 44.8068 45.4426 44.8068 44.3256V35.0706L44.6725 34.7728C46.8515 36.6714 49.7102 37.7832 52.8296 37.7832C59.6181 37.7832 65.1723 32.5175 65.1723 25.3368C65.1723 18.1562 59.6181 13.05 52.8296 13.05C48.5979 13.05 44.9394 15.0062 42.7274 18.1238ZM32.6183 33.9536C36.9383 33.9536 40.4868 30.4431 40.4868 25.4964C40.4868 20.5497 36.9383 17.0392 32.6183 17.0392C28.2984 17.0392 24.7499 20.5497 24.7499 25.4964C24.7499 30.2835 28.2984 33.9536 32.6183 33.9536ZM52.8294 33.9536C57.1493 33.9536 60.6978 30.4431 60.6978 25.4964C60.6978 20.5497 57.1493 17.0392 52.8294 17.0392C48.5094 17.0392 44.9609 20.5497 44.9609 25.4964C44.9609 30.2835 48.5094 33.9536 52.8294 33.9536Z",
          fill: "#223066"
        }
      )
    ]
  }
);
const VpPaymentPointspayAsset = forwardRef(PaymentPointspayAsset);

export { VpPaymentPointspayAsset as default };
